(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["basson-forge-home"] && !Shopify.designMode) return;
  try {
    
(function(){
  function initHomeReviews(root){
    if(!root || root.dataset.carouselReady==='true') return;
    var viewport=root.querySelector('[data-review-viewport]');
    var track=root.querySelector('[data-review-track]');
    var prev=root.querySelector('[data-review-prev]');
    var next=root.querySelector('[data-review-next]');
    if(!viewport||!track||!prev||!next) return;
    var cards=Array.prototype.slice.call(track.querySelectorAll('[data-review-card]'));
    if(!cards.length) return;
    root.dataset.carouselReady='true';
    var index=0;
    var timer=null;
    var autoplay=root.dataset.autoplay==='true';
    var delay=parseInt(root.dataset.delay,10)||7000;
    var reduce=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function visibleCount(){return 1;}
    function maxIndex(){return Math.max(0,cards.length-visibleCount());}
    function cardWidth(){return cards[0].getBoundingClientRect().width;}
    function goTo(i,smooth){
      var max=maxIndex();
      if(i>max)i=0;
      if(i<0)i=max;
      index=i;
      viewport.scrollTo({left:cardWidth()*index,behavior:smooth&&!reduce?'smooth':'auto'});
    }
    function sync(){
      var w=cardWidth();if(!w)return;
      index=Math.min(maxIndex(),Math.max(0,Math.round(viewport.scrollLeft/w)));
    }
    function stop(){if(timer){window.clearInterval(timer);timer=null;}}
    function start(){stop();if(autoplay&&!reduce&&cards.length>visibleCount()){timer=window.setInterval(function(){goTo(index+1,true);},delay);}}
    prev.addEventListener('click',function(){stop();goTo(index-1,true);start();});
    next.addEventListener('click',function(){stop();goTo(index+1,true);start();});
    viewport.addEventListener('scroll',function(){window.clearTimeout(viewport._reviewScrollTimer);viewport._reviewScrollTimer=window.setTimeout(sync,120);},{passive:true});
    viewport.addEventListener('keydown',function(e){if(e.key==='ArrowLeft'){e.preventDefault();prev.click();}if(e.key==='ArrowRight'){e.preventDefault();next.click();}});
    root.addEventListener('mouseenter',stop);
    root.addEventListener('mouseleave',start);
    root.addEventListener('focusin',stop);
    root.addEventListener('focusout',start);
    root.addEventListener('touchstart',stop,{passive:true});
    root.addEventListener('touchend',start,{passive:true});
    window.addEventListener('resize',function(){goTo(Math.min(index,maxIndex()),false);start();});
    start();
  }
  function initAll(){document.querySelectorAll('[data-home-reviews]').forEach(initHomeReviews);}
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',initAll);}else{initAll();}
  document.addEventListener('shopify:section:load',initAll);
})();

  } catch(e) { console.error(e); }
})();
})();
